import React from 'react';
import { TextInput, type TextInputProps } from 'react-native';
import { cn } from '@/utils/cn';

export interface InputProps extends TextInputProps {
  className?: string;
}

export const Input = React.forwardRef<TextInput, InputProps>(({ className, style, ...props }, ref) => {
  return (
    <TextInput
      ref={ref}
      placeholderTextColor="#A3A3A3"
      className={cn(
        'flex h-12 w-full rounded-xl border border-neutral-200 bg-card px-4 py-2 text-base text-foreground',
        'focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      style={[{ borderCurve: 'continuous' }, style]}
      {...props}
    />
  );
});

Input.displayName = 'Input';
